import { c as _c } from "react/compiler-runtime";
import { PAYPAL_REST_API } from 'modules/profile/payment-gateways/integrations/paypal-rest/api';
import { PaypalRestApiInterface } from 'modules/profile/payment-gateways/integrations/paypal-rest/types';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const usePaypalRestApi = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: connectFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: confirmFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] !== connectFetcher) {
    t3 = redirectLink => connectFetcher(`${PAYPAL_REST_API}/connect`, {
      redirectLink
    });
    $[3] = connectFetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== confirmFetcher) {
    t4 = body => confirmFetcher(`${PAYPAL_REST_API}/connect/confirm`, body);
    $[5] = confirmFetcher;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== deleteFetcher) {
    t5 = () => deleteFetcher(`${PAYPAL_REST_API}/disconnect`);
    $[7] = deleteFetcher;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = {
      connect: t3,
      confirmConnect: t4,
      disconnect: t5
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};